import { render, staticRenderFns } from "./transfer-warehouse-edit.vue?vue&type=template&id=3bfcce70&scoped=true&"
import script from "./transfer-warehouse-edit.vue?vue&type=script&lang=ts&"
export * from "./transfer-warehouse-edit.vue?vue&type=script&lang=ts&"
import style0 from "./transfer-warehouse-edit.vue?vue&type=style&index=0&id=3bfcce70&prod&lang=scss&scoped=true&"
import style1 from "./transfer-warehouse-edit.vue?vue&type=style&index=1&id=3bfcce70&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bfcce70",
  null
  
)

export default component.exports